import { Fragment } from "react";
import { ChevronRight } from "lucide-react";

import Panel from "../Panel";
import Skeleton from "../Skeleton";
import { Member, computeFunnel } from "../../../utils/partnerMetrics";
import { Row, Stage, StageValue, StageLabel, StagePct, Arrow } from "./styles";

interface MemberFunnelProps {
  members: Member[];
  loading?: boolean;
}

const MemberFunnel = ({ members, loading }: MemberFunnelProps) => {
  if (loading) {
    return (
      <Panel title="Member Funnel">
        <Row>
          {Array.from({ length: 4 }).map((_, i) => (
            <Fragment key={i}>
              <Stage>
                <Skeleton $w="40%" $h="26px" $radius="8px" $mb="6px" />
                <Skeleton $w="70%" $h="12px" />
              </Stage>
              {i < 3 && (
                <Arrow>
                  <ChevronRight size={20} />
                </Arrow>
              )}
            </Fragment>
          ))}
        </Row>
      </Panel>
    );
  }

  const stages = computeFunnel(members);

  return (
    <Panel title="Member Funnel">
      <Row>
        {stages.map((s, i) => {
          const prev = i > 0 ? stages[i - 1].value : 0;
          const pct = i > 0 && prev > 0 ? Math.round((s.value / prev) * 100) : null;
          return (
            <Fragment key={s.key}>
              <Stage>
                <StageValue>{s.value}</StageValue>
                <StageLabel>{s.label}</StageLabel>
                {pct !== null && <StagePct>{pct}% of previous</StagePct>}
              </Stage>
              {i < stages.length - 1 && (
                <Arrow>
                  <ChevronRight size={20} />
                </Arrow>
              )}
            </Fragment>
          );
        })}
      </Row>
    </Panel>
  );
};

export default MemberFunnel;
